<script>
    let items = [
        {
            title: "Передача и возврат Товара",
            text: "Продавец в срок не позднее 24 часов после оформления Покупателем заказа и осуществления 100% (сто процентной) оплаты направляет Покупателю на электронный адрес, указанный при оформлении заказа, Товар (электронный документ в формате *.PDF) или предоставляет возможность самостоятельного скачивания с сайта Продавца (при наличии технической возможности).\n После оформления и оплаты заказа Покупатель не имеет права отказаться от услуг Продавца, так как не предусмотрен возврат товара.",
        },
    ];
    let shownIndex = -1; // Индекс показанного текста (-1 означает, что никакой текст не показан)

    function toggleText(index) {
        if (shownIndex === index) {
            shownIndex = -1; // Скрыть, если текст уже показан
        } else {
            shownIndex = index; // Показать выбранный текст
        }
    }
</script>

<section id="bottomBlock">
    <div class="module6">
        <div class="container">
            <div class="blockText">
                <div class="text-container">
                    <p class="text1">СЕМЕЙНЫЙ ПУТЕВОДИТЕЛЬ</p>
                    <p class="text2">
                        ТВОЙ НАВИГАТОР ИНТЕРЕСНЫХ ПУТЕШЕСТВИЙ ПО МОСКВЕ И РОССИИ
                    </p>
                </div>
                <div class="links-container">
                    <li>
                        <a class="link" href="/workingOut">Гайды по Москве</a>
                    </li>
                    <li>
                        <a class="link" href="/workingOut">Гайды по России</a>
                    </li>
                    <li><a class="link" href="/workingOut">Экскурсии</a></li>
                    <li>
                        <a class="link" href="/sanatoriums"
                            >Санатории для детей</a
                        >
                    </li>
                </div>
            </div>
            <div class="icons">
                <a class="link_icon" href="https://t.me/travelfamilyguide">
                    <img
                        src="photo/IMG_6_1.jpg"
                        class="photo"
                        alt="иконка_тгк"
                    />
                </a>
                <a class="link_icon" href="https://youtube.com/@ivanovafamily">
                    <img
                        src="photo/IMG_6_2.jpg"
                        class="photo"
                        alt="иконка_youtube"
                    />
                </a>
                <a
                    class="link_icon"
                    href="https://rutube.ru/u/travelfamilyguide"
                >
                    <img
                        src="photo/IMG_6_3.jpg"
                        class="photo"
                        alt="иконка_rutube"
                    />
                </a>
                <a
                    class="link_icon"
                    href="https://instagram.com/travel.family.guide"
                >
                    <img
                        src="photo/IMG_6_4.jpg"
                        class="photo"
                        alt="иконка_instagram"
                    />
                </a>
                <a class="link_icon" href="https://vk.com/travelfamilyguide">
                    <img
                        src="photo/IMG_6_5.jpg"
                        class="photo"
                        alt="иконка_vk"
                    />
                </a>
                <a class="link_icon" href="mailto:travelfamilyguide@gmail.com">
                    <img
                        src="photo/IMG_6_6.jpg"
                        class="photo"
                        alt="иконка_почты"
                    />
                </a>
            </div>
            <hr class="hr" />
            <div class="blockText">
                <div class="text-containerDown">
                    <p class="textDown">Самозанятый Иванова Елена Алексеевна</p>
                    <p class="textDown">ИНН 771672668877</p>
                    <p class="textDown">г. Москва</p>
                    <div class="textDown">
                        E-mail:
                        <a
                            class="textEmail"
                            href="mailto:travelfamilyguide@gmail.com"
                        >
                            travelfamilyguide@gmail.com
                        </a>
                    </div>
                </div>
            </div>
            <div class="itemGroup">
                {#each items as item, i}
                    <div
                        class="item"
                        on:click={() => toggleText(i)}
                        on:keydown={(e) => {
                            if (e.key === "Enter") toggleText(i);
                        }}
                    >
                        <div class="itemHeader" class:active={shownIndex === i}>
                            {item.title}
                        </div>
                        {#if shownIndex === i}
                            <div class="shownText">
                                <ul>
                                    {#each item.text.split("\n") as line}
                                        <li>{line.trim()}</li>
                                    {/each}
                                </ul>
                            </div>
                        {/if}
                        </div>
                {/each}
            </div>
            <div class="blockPdf">
                <a
                    class="pdf"
                    href="/pdf/Оферта_Семейный_Путеводитель_RU.pdf"
                    download>Оферта Семейный Путеводитель PDF</a
                >
                <a
                    class="pdf"
                    href="/pdf/Политика_в_отношении_обработки_персональных_данных_RU.pdf"
                    download
                    >Политика в отношении обработки персональных данных PDF</a
                >
            </div>
        </div>
    </div>
</section>

<style>
    .module6 {
        width: 100%;
        height: auto;
        background-color: #4f7942;
    }
    .container {
        margin: 0 auto;
    }
    .blockText,
    .blockPdf {
        text-align: left;
        display: flex;
        flex-direction: column;
    }
    .blockText {
        gap: 20px;
    }

    .text-container {
        width: fit-content; /*Или auto*/
    }

    .text1,
    .text2 {
        margin: 0 auto;
        color: #eaf4e5;
    }

    .links-container {
        width: fit-content; /*Или auto*/
        list-style: none;
    }

    .link {
        padding-bottom: 5px; /*Внутренний отступ снизу(от слова)*/
        margin-top: 10px;
        margin-bottom: 10px; /*Отступ от бордера до следующего блока*/
        display: block; /*Тип блока ПОЧИТАТЬ!!!*/
        width: fit-content; /*Ширина по контенту*/

        font-size: 17px;
        font-weight: 300;
        color: #eaf4e5;
        text-decoration: none;
        transition: cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;

        /* cursor: pointer; */
    }

    .link:hover {
        /* color: #eaf4e5; */
        border-bottom: solid 1px #eaf4e5;
    }

    .icons {
        display: flex;
        margin: 0 auto;
    }
    .photo {
        width: 100%;
        height: 100%;
    }

    .hr {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .text-containerDown {
        margin-top: 10px;
    }

    .textDown {
        margin: 0 auto;
        color: #eaf4e5;
        font-size: 15px;
        font-weight: 100;
        margin-bottom: 10px;
    }
    .textEmail, .itemHeader, .shownText{
        margin: 0 auto;
        color: #eaf4e5;
        font-size: 15px;
        font-weight: 100;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .itemGroup {
        margin: 0 auto;
        display: grid;
        grid-gap: 20px;
        justify-content: left;
    }
    .itemHeader::after {
        content: "\25BC";
        font-size: 16px;
        margin-left: 10px;
        transition: transform 0.3s ease;
    }
    .itemHeader.active::after {
        transform: rotate(180deg);
    }
    .itemHeader:hover {
        background-color: #e0e0e0;
    }

    .pdf {
        /* text-decoration: none; */
        color: #eaf4e5;
        font-size: 15px;
        font-weight: 100;
        margin-bottom: 10px;
    }

    @media (min-width: 1280px) {
        .container {
            max-width: 50%;
        }
        .module6 {
            padding: 50px 0px 50px 0px;
        }
        .text1 {
            font-size: 30px;
            font-weight: 600;
        }
        .text2 {
            font-size: 15px;
            font-weight: 600;
        }
        .icons {
            max-width: 75%;
            gap: 30px;
            margin-top: 10px;
        }
        .hr {
            max-width: 50%;
        }
    }
    @media (max-width: 480px) {
        .container {
            max-width: 90%;
        }
        .module6 {
            padding: 20px 0px 20px 0px;
        }
        .text1 {
            font-size: 20px;
            font-weight: 600;
        }
        .text2 {
            font-size: 10px;
            font-weight: 600;
        }
        .icons {
            max-width: 100%;
            gap: 20px;
            margin-top: 25px;
        }
        .hr {
            max-width: 90%;
        }
    }
    @media (min-width: 481px) and (max-width: 833px) {
        /*Телефон горизонталь*/
        .container {
            max-width: 90%;
        }
        .module6 {
            padding: 20px 0px 20px 0px;
        }
        .text1 {
            font-size: 25px;
            font-weight: 600;
        }
        .text2 {
            font-size: 15px;
            font-weight: 600;
        }
        .icons {
            max-width: 100%;
            gap: 50px;
            margin-top: 25px;
        }
        .hr {
            max-width: 90%;
        }
    }
    @media (min-width: 834px) and (max-width: 1023px) {
        /*Планшет*/
        .container {
            max-width: 90%;
        }
        .module6 {
            padding: 20px 0px 20px 0px;
        }
        .text1 {
            font-size: 25px;
            font-weight: 600;
        }
        .text2 {
            font-size: 15px;
            font-weight: 600;
        }
        .icons {
            max-width: 100%;
            gap: 50px;
            margin-top: 25px;
        }
        .hr {
            max-width: 90%;
        }
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
        /*Планшет2*/
        .container {
            max-width: 90%;
        }
        .module6 {
            padding: 20px 0px 20px 0px;
        }
        .text1 {
            font-size: 25px;
            font-weight: 600;
        }
        .text2 {
            font-size: 15px;
            font-weight: 600;
        }
        .icons {
            max-width: 100%;
            gap: 50px;
            margin-top: 25px;
        }
        .hr {
            max-width: 90%;
        }
    }
</style>
